import React, { useContext, useEffect, useState } from "react"
import axios from "axios"
import * as AppConstants from "../../utility/AppConstants"
import ChartRegioni from "../graph/ChartRegioni"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import ChartRegionaliMultiAnno from "../graph/multiAnno/ChartRegionaliMultiAnno"

interface SliderGraficiRegionaliProps {
    codIsa: string
    macroarea: string
    anno: string
    datiRegionali: any
}

function SliderGraficiRegionali(props: SliderGraficiRegionaliProps) {
    let codIsa = props.codIsa
    let macroarea = props.macroarea
    let anno = props.anno
    let datiRegionali = props.datiRegionali

    const [dati, setDati] = useState(null)
    const [multiannoState, _] = useContext(MultiAnnoContext)

    useEffect(() => {
        const url = AppConstants.URL_GRAFICO_REGIONI
        const config = AppConstants.HEADER_CONFIG

        let id = 0
        if (codIsa !== undefined && codIsa !== null) {
            id = 2
        }

        if (macroarea !== undefined && macroarea !== null) {
            id = 1
        }
        const cancel = axios.CancelToken
        let source = cancel.source()

        axios
            .get(url, {
                params: {
                    anno: anno,
                    id: id,
                    codIsa: codIsa,
                    macroarea: macroarea
                    //cancelToken: source.token
                },
                headers: config
            })
            .then((response) => {
                setDati(response.data)
            })
            .catch((err) => {
                //console.log(err);
            })
        return () => {
            //source.cancel()
        }
    }, [codIsa, macroarea, anno])

    return (
        <div className="row">
            {!multiannoState.isMultiAnno ? (
                <div className="col-2">&nbsp;</div>
            ) : null}
            <div className={!multiannoState.isMultiAnno ? "col-8" : "col-12"}>
                <div
                    id="custom-slider"
                    className="carousel slide"
                    data-interval="false"
                >
                    <div
                        style={
                            multiannoState.isMultiAnno
                                ? {
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center"
                                  }
                                : { display: "flex" }
                        }
                        className=""
                    >
                        <div
                            className="carousel-item active"
                            style={
                                multiannoState.isMultiAnno
                                    ? { width: "auto", margin: 0 }
                                    : undefined
                            }
                            aria-hidden="false"
                        >
                            {dati !== null &&
                                (multiannoState.isMultiAnno ? (
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="Numero Posizioni"
                                        anno={Number(anno)}
                                        dataKey="numPosizioni"
                                    />
                                ) : (
                                    <ChartRegioni
                                        datiRegionali={datiRegionali}
                                        datiGrafico={dati}
                                        dataType="numeroPosizioni"
                                    />
                                ))}
                            {/* <img className="card-img-top order-sm-2" alt="" src={`data:image/png;base64,${img2}`} /> */}
                        </div>
                        <div
                            className="carousel-item  "
                            style={
                                multiannoState.isMultiAnno
                                    ? { width: "auto", margin: 0 }
                                    : undefined
                            }
                            aria-hidden="false"
                        >
                            {dati !== null &&
                                (multiannoState.isMultiAnno ? (
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="Numero Addetti"
                                        anno={Number(anno)}
                                        dataKey="numAddetti"
                                    />
                                ) : (
                                    <ChartRegioni
                                        datiRegionali={datiRegionali}
                                        datiGrafico={dati}
                                        dataType="numeroAddetti"
                                    />
                                ))}
                            {/* <img className="card-img-top order-sm-2" alt="" src={`data:image/png;base64,${img1}`} /> */}
                        </div>
                        <div
                            className="carousel-item"
                            style={
                                multiannoState.isMultiAnno
                                    ? { width: "auto", margin: 0 }
                                    : undefined
                            }
                            aria-hidden="false"
                        >
                            {dati !== null &&
                                (multiannoState.isMultiAnno ? (
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="Ricavi / Compensi (MEDIA)"
                                        anno={Number(anno)}
                                        dataKey="ricCompDic"
                                    />
                                ) : (
                                    <ChartRegioni
                                        datiRegionali={datiRegionali}
                                        datiGrafico={dati}
                                        dataType="ricaviCompensi"
                                    />
                                ))}
                            {/* <img className="card-img-top order-sm-2" alt="" src={`data:image/png;base64,${img4}`} /> */}
                        </div>
                        <div
                            className="carousel-item"
                            style={
                                multiannoState.isMultiAnno
                                    ? { width: "auto", margin: 0 }
                                    : undefined
                            }
                            aria-hidden="false"
                        >
                            {dati !== null &&
                                (multiannoState.isMultiAnno ? (
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="Redditi (MEDIA)"
                                        anno={Number(anno)}
                                        dataKey="reddDic"
                                    />
                                ) : (
                                    <ChartRegioni
                                        datiRegionali={datiRegionali}
                                        datiGrafico={dati}
                                        dataType="redditi"
                                    />
                                ))}
                            {/* <img className="card-img-top order-sm-2" alt="" src={`data:image/png;base64,${img3}`} /> */}
                        </div>

                        <div
                            className="carousel-item"
                            style={
                                multiannoState.isMultiAnno
                                    ? { width: "auto", margin: 0 }
                                    : undefined
                            }
                            aria-hidden="false"
                        >
                            {dati !== null &&
                                (multiannoState.isMultiAnno ? (
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="Punteggio Isa (MEDIA)"
                                        anno={Number(anno)}
                                        dataKey="punteggioIsaAnom"
                                    />
                                ) : (
                                    <ChartRegioni
                                        datiRegionali={datiRegionali}
                                        datiGrafico={dati}
                                        dataType="punteggioIsaAnomalie"
                                    />
                                ))}
                            {/* <img className="card-img-top order-sm-2" alt="" src={`data:image/png;base64,${img5}`} /> */}
                        </div>
                        {/*dati !== null &&
                            (multiannoState.isMultiAnno ? (
                                <div
                                    className="carousel-item"
                                    style={
                                        multiannoState.isMultiAnno
                                            ? { width: "auto", margin: 0 }
                                            : undefined
                                    }
                                    aria-hidden="false"
                                >
                                    <ChartRegionaliMultiAnno
                                        data={datiRegionali}
                                        title="PUNTEGGIO ISA SENZA ANOMALIE (MEDIA)"
                                        anno={Number(anno)}
                                        dataKey="punteggioIsaNonAnom"
                                    />
                                </div>
                                ) : null)*/}
                    </div>
                    <a
                        className="carousel-control-prev icon-primary"
                        href="#custom-slider"
                        role="button"
                        data-slide="prev"
                        aria-hidden="true"
                    >
                        <i className="fas fa-chevron-left fa-2x"></i>
                    </a>
                    <a
                        className="carousel-control-next icon-primary"
                        href="#custom-slider"
                        role="button"
                        data-slide="next"
                        aria-hidden="true"
                    >
                        <i className="fas fa-chevron-right fa-2x"></i>
                    </a>
                    <ol className="carousel-indicators" aria-hidden="true">
                        <li
                            data-target="#custom-slider"
                            data-slide-to="0"
                            className="active"
                        ></li>
                        <li data-target="#custom-slider" data-slide-to="1"></li>
                        <li data-target="#custom-slider" data-slide-to="2"></li>
                        <li data-target="#custom-slider" data-slide-to="3"></li>
                        <li data-target="#custom-slider" data-slide-to="4"></li>
                        {multiannoState.isMultiAnno ? (
                            <li
                                data-target="#custom-slider"
                                data-slide-to="5"
                            ></li>
                        ) : null}
                    </ol>
                </div>
            </div>
            {!multiannoState.isMultiAnno ? (
                <div className="col-2">&nbsp;</div>
            ) : null}
        </div>
    )
}
export default SliderGraficiRegionali
